import { useRef, useState, useEffect, useContext } from 'react';

import { DataContext } from 'providers/data';

import { ParamsListStores } from 'utils/typeServices';

import Modals from 'components/views/Modals';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ButtonRectangle } from 'components/views/form/Button';

import { ReactComponent as IcShared } from 'assets/icons/ic-shared.svg';

import { Container, ContainerModal, ContentBox, ContentGrid, ContentTimesBtn, RiskGreen, Card, ButtonCancel } from './styles';

const CardStore = ({ NOME_LOJA, NR_DISTANCIA, NM_ENDERECO, NR_NUMERO, NM_BAIRRO, NM_CIDADE, NR_CEP, CD_LOJA, date, hours, isStoreSelected, isSelected, isIndexStore, DS_PONTO_REFERENCIA, isExchanges = false, isSchedulingUninstall = false, CD_PEDIDO = 0, NR_PLATAFORMA, isWebView, isMaintenance = false }: ParamsListStores) => {
    const [nuPeriod, setNuPeriod] = useState(0);
    const refAddress = useRef<HTMLDivElement>(null);
    const [tourTime, setTourTime] = useState<string>();
    const [activeBtn, setActiveBtn] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [enableModal, setEnableModal] = useState(false);

    const [selectedStore, setSelectedStore] = useState<ParamsListStores>();

    const { dataEffectSchedule, selectedCar, dataOrderDetailScheduling, dataConfirmOrder, dataGetListarCotacoes, handlePostEffectSchedule, handlePostAgendamentoDesinstalacao } = useContext(DataContext);

    const handlePostEffectScheduleState = () => {
        setIsLoading(true);
        if (isSchedulingUninstall && selectedStore && CD_PEDIDO && NR_PLATAFORMA && !isMaintenance) {
            handlePostAgendamentoDesinstalacao({
                token: localStorage.getItem('token')!,
                body: {
                    CD_PEDIDO: CD_PEDIDO,
                    NR_TIPO_AGENDAMENTO: 2,
                    FL_DOMICILIAR: false,
                    CD_PESSOA_LOJA: selectedStore.CD_LOJA,
                    NR_PERIODO: nuPeriod,
                    DT_AGENDAMENTO: new Date(`${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]}`).toISOString(),
                    NR_CEP: selectedStore.NR_CEP,
                    NM_ENDERECO: selectedStore.NM_ENDERECO,
                    NR_NUMERO: `${selectedStore.NR_NUMERO}`,
                    DS_COMPLEMENTO: '',
                    NM_BAIRRO: selectedStore.NM_BAIRRO,
                    DS_PONTO_REFERENCIA: selectedStore.DS_PONTO_REFERENCIA,
                    NM_CONTATO: '',
                    NR_TELEFONE_CONTATO: '',
                    CD_SEGMENTO: 0,
                    FL_TROCA_SERVICO: false
                },
                NR_PLATAFORMA: NR_PLATAFORMA
            });
        } else if (isMaintenance && selectedStore && CD_PEDIDO) {
            handlePostEffectSchedule({
                token: localStorage.getItem('token')!,
                body: {
                    CD_PEDIDO: CD_PEDIDO,
                    NR_TIPO_AGENDAMENTO: 9,
                    FL_DOMICILIAR: false,
                    CD_PESSOA_LOJA: selectedStore.CD_LOJA,
                    NR_PERIODO: nuPeriod,
                    DT_AGENDAMENTO: new Date(`${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]}`).toISOString(),
                    NR_CEP: selectedStore.NR_CEP,
                    NM_ENDERECO: selectedStore.NM_ENDERECO,
                    NR_NUMERO: `${selectedStore.NR_NUMERO}`,
                    DS_COMPLEMENTO: '',
                    NM_BAIRRO: selectedStore.NM_BAIRRO,
                    DS_PONTO_REFERENCIA: selectedStore.DS_PONTO_REFERENCIA,
                    NM_CONTATO: '',
                    NR_TELEFONE_CONTATO: '',
                    CD_SEGMENTO: 0,
                    FL_TROCA_SERVICO: false
                },
                isWebView
            });
        } else {
            if (selectedStore) {
                if (isExchanges && (dataConfirmOrder || dataGetListarCotacoes) && selectedCar) {
                    handlePostEffectSchedule({
                        token: localStorage.getItem('token')!,
                        body: {
                            CD_PEDIDO: dataConfirmOrder ? dataConfirmOrder?.order?.cD_PEDIDO : dataGetListarCotacoes?.cD_PEDIDO_NOVO!,
                            NR_TIPO_AGENDAMENTO: 11,
                            FL_DOMICILIAR: false,
                            CD_PESSOA_LOJA: selectedStore.CD_LOJA,
                            NR_PERIODO: nuPeriod,
                            DT_AGENDAMENTO: new Date(`${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]}`).toISOString(),
                            NR_CEP: selectedStore.NR_CEP,
                            NM_ENDERECO: selectedStore.NM_ENDERECO,
                            NR_NUMERO: `${selectedStore.NR_NUMERO}`,
                            DS_COMPLEMENTO: '',
                            NM_BAIRRO: selectedStore.NM_BAIRRO,
                            DS_PONTO_REFERENCIA: selectedStore.DS_PONTO_REFERENCIA,
                            NM_CONTATO: '',
                            NR_TELEFONE_CONTATO: '',
                            CD_SEGMENTO: selectedCar.CD_SEGMENTO,
                            FL_TROCA_SERVICO: true
                        },
                        isExchanges: true,
                        isWebView
                    });
                } else if (dataOrderDetailScheduling) {
                    handlePostEffectSchedule({
                        token: localStorage.getItem('token')!,
                        body: {
                            CD_PEDIDO: dataOrderDetailScheduling.CD_PEDIDO,
                            NR_TIPO_AGENDAMENTO: dataOrderDetailScheduling.NR_TIPO_AGENDAMENTO,
                            FL_DOMICILIAR: false,
                            CD_PESSOA_LOJA: selectedStore.CD_LOJA,
                            NR_PERIODO: nuPeriod,
                            DT_AGENDAMENTO: new Date(`${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]}`).toISOString(),
                            NR_CEP: selectedStore.NR_CEP,
                            NM_ENDERECO: selectedStore.NM_ENDERECO,
                            NR_NUMERO: `${selectedStore.NR_NUMERO}`,
                            DS_COMPLEMENTO: '',
                            NM_BAIRRO: selectedStore.NM_BAIRRO,
                            DS_PONTO_REFERENCIA: selectedStore.DS_PONTO_REFERENCIA,
                            NM_CONTATO: '',
                            NR_TELEFONE_CONTATO: '',
                            CD_SEGMENTO: dataOrderDetailScheduling.CD_SEGMENTO,
                            FL_TROCA_SERVICO: false
                        },
                        isWebView
                    });
                }
            }
        }

    }

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>, NR_PERIODO: number) => {
        setNuPeriod(NR_PERIODO);
        setTourTime(e.target.value);
        if (typeof isIndexStore === 'number') {
            isStoreSelected && isStoreSelected(isIndexStore);
        }
    }

    useEffect(() => {
        if (tourTime && (isSelected === isIndexStore)) {
            setActiveBtn(false);
        } else {
            setActiveBtn(true);
            setTourTime('');
        }
    }, [tourTime, isSelected, isIndexStore]);

    useEffect(() => {
        if (dataEffectSchedule) {
            setEnableModal(false);
            setIsLoading(false);
        } else if (dataEffectSchedule === false) {
            setEnableModal(false);
            setIsLoading(false);
        }
    }, [dataEffectSchedule]);

    return (
        <Container>
            <Typography fontSize='1.25rem' fontWeight={700} paddingBottom='.5rem'>
                {NOME_LOJA}
            </Typography>

            <ContentGrid>
                <Typography fontSize='.65rem' sx={{ color: '#86898B', gridArea: 'distance' }}>
                    <span style={{ fontSize: '1.25rem', color: '#17A7E0', fontWeight: 700 }}>{NR_DISTANCIA}km</span> distância do CEP informado
                </Typography>

                <RiskGreen style={{ gridArea: 'risk' }}>
                    <div />
                    <span />
                </RiskGreen>

                <Box className='address' sx={{ gridArea: 'address', 'a': { color: 'grey.400' } }}>
                    <Typography ref={refAddress} fontSize='.75rem' color='grey.500' padding={0} textTransform='capitalize'>
                        {NM_ENDERECO}, {NR_NUMERO}, {NM_BAIRRO}, {NM_CIDADE}
                    </Typography>
                    <a href={`http://maps.google.com/?q=${NR_CEP},${NM_CIDADE},${NM_ENDERECO},${NM_BAIRRO},${NR_NUMERO}`} target='blank'>
                        <IcShared />
                    </a>
                </Box>
            </ContentGrid>

            <ContentTimesBtn>
                <Box className="box-hours">
                    {hours.map(({ DT_HORARIO, NR_PERIODO }, index) => (
                        <li key={index}>
                            <input
                                style={{ cursor: 'pointer' }}
                                id={`${isIndexStore}_${DT_HORARIO}`}
                                type="radio"
                                checked={`${isIndexStore}_${DT_HORARIO}` === tourTime}
                                value={`${isIndexStore}_${DT_HORARIO}`}
                                onChange={(e) => handleOnChange(e, NR_PERIODO)}
                            />
                            <label htmlFor={`${isIndexStore}_${DT_HORARIO}`}>{DT_HORARIO}</label>
                        </li>
                    ))}
                </Box>

                <Box sx={{
                    'button': {
                        position: 'absolute',
                        bottom: '1.46rem',
                        maxWidth: '13.75rem'
                    }
                }}>
                    <ButtonRectangle
                        name='AGENDAR'
                        disabled={activeBtn}
                        onClick={() => {
                            setSelectedStore({
                                NOME_LOJA,
                                NR_DISTANCIA,
                                NM_ENDERECO,
                                NR_NUMERO,
                                NM_BAIRRO,
                                NM_CIDADE,
                                NR_CEP,
                                CD_LOJA,
                                date,
                                hours,
                                DS_PONTO_REFERENCIA,
                                isStoreSelected,
                                isSelected,
                                isIndexStore,
                                isWebView
                            });
                            setEnableModal(true);
                        }} />
                </Box>
            </ContentTimesBtn>

            <Modals open={enableModal}>
                <ContainerModal>
                    <nav>
                        <Typography fontWeight={700}>
                            {isSchedulingUninstall || isExchanges ? 'AGENDAMENTO' : 'REAGENDAMENTO'}
                        </Typography>
                    </nav>

                    <ContentBox>
                        <Typography fontWeight={700}>
                            LOJA SELECIONADA:
                        </Typography>
                        <RiskGreen >
                            <div />
                            <span />
                        </RiskGreen>
                        <Card>
                            <Box className='address'>
                                <Typography className='title' color='primary.light' fontWeight={700} textAlign='center'>
                                    {selectedStore?.NOME_LOJA}
                                </Typography>
                                <Typography fontSize='.65rem' sx={{ color: '#86898B', textAlign: 'start' }}>
                                    <span style={{ fontSize: '1.25rem', color: '#17A7E0', fontWeight: 700 }}>{selectedStore?.NR_DISTANCIA}km</span> distância do CEP informado
                                </Typography>
                                <Box sx={{ display: 'flex', gap: '.5rem', textAlign: 'start' }}>
                                    <Typography sx={{ maxWidth: '15rem' }} ref={refAddress} fontSize='.75rem' color='grey.500' padding={0} textTransform='capitalize'>
                                        {selectedStore?.NM_ENDERECO}, {selectedStore?.NR_NUMERO}, {selectedStore?.NM_BAIRRO}, {selectedStore?.NM_CIDADE}
                                    </Typography>
                                    <a href={`http://maps.google.com/?q=${selectedStore?.NR_CEP},${selectedStore?.NM_CIDADE},${selectedStore?.NM_ENDERECO},${selectedStore?.NM_BAIRRO},${selectedStore?.NR_NUMERO}`} target='blank'>
                                        <IcShared />
                                    </a>
                                </Box>
                            </Box>
                        </Card>
                    </ContentBox>

                    <ContentBox>
                        <Typography fontWeight={700}>
                            {!isSchedulingUninstall && 'NOVA '}DATA:
                        </Typography>
                        <RiskGreen >
                            <div />
                            <span />
                        </RiskGreen>
                        <Card>
                            <Typography fontWeight={700} color='primary.light' sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                <span>
                                    {selectedStore?.date}
                                </span>
                                <span style={{ textTransform: 'uppercase' }}>
                                    {tourTime?.split('_')[1]}
                                </span>
                            </Typography>
                        </Card>
                    </ContentBox>
                    {dataOrderDetailScheduling && dataOrderDetailScheduling.TAXA_REAGENDAMENTO &&
                        <ContentBox>
                            <Typography fontWeight={700}>
                                {isSchedulingUninstall ? 'TAXA DE AGENDAMENTO:' : 'TAXA DE REAGENDAMENTO:'}
                            </Typography>
                            <RiskGreen >
                                <div />
                                <span />
                            </RiskGreen>
                            <Box sx={{ paddingBottom: '.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', alignItems: 'flex-end' }}>
                                <Card>
                                    <Typography fontWeight={700} color='primary.light'>
                                        R$ {dataOrderDetailScheduling.VL_TOTAL.toFixed(2)}
                                    </Typography>
                                </Card>
                                <Typography color='error' className='frustrated-text'>
                                    O boleto deve ser quitado em até 3
                                    horas antes da {isSchedulingUninstall || (dataOrderDetailScheduling.NR_TIPO_AGENDAMENTO === 2) ? 'desinstalação' : 'instalação'}.
                                </Typography>
                            </Box>
                        </ContentBox>
                    }

                    <ContentBox className='box-btn'>
                        <ButtonRectangle name='CONFIRMAR' loadingBtn={isLoading} onClick={() => handlePostEffectScheduleState()} />
                        <ButtonCancel
                            fullWidth
                            variant='outlined'
                            onClick={() => setEnableModal(false)}>
                            CANCELAR
                        </ButtonCancel>
                    </ContentBox>
                </ContainerModal>
            </Modals>
        </Container>
    );
}

export default CardStore;